import React from 'react';

export const Sender = ({ item }) => (
    <span className="lv-small date-block">
        <span className="lv-small">{item.townName}</span>
        <br />
        <span className="lv-small">{item.senderName}</span>
    </span>
);
